module.exports = __webpack_public_path__ + "static/Sifchain-8bb81121ecc715114b1242e6e1071c86.svg";